export default __webpack_public_path__ + "static/media/add-lists.5e2ea6c4.png";